<template>
  <div id="export_download" class="w-full flex justify-end pr-3">
    <a-button
      v-if="row.export_status === exportStatuses.COMPLETED"
      class="secondary_small bg-transparent shadow-none"
      :disabled="downloading"
      @click="downloadFile"
    >
      <ThemeImage
        v-if="!downloading"
        :icon="imageNames.DOWNLOAD_GREY"
        alt="download_icon"
        class="size-4"
      />
      <CustomLoader v-else size="16" text="" border-width="3" />
    </a-button>
    <span
      v-else-if="row.export_status === exportStatuses.FAILED"
      class="secondary_color text-sm"
      >Export Failed</span
    >
    <span class="secondary_color text-sm" v-else>In Progress</span>
  </div>
</template>
<script setup>
import { defineProps, ref } from "vue";
import CustomLoader from "@/src/components/CustomLoader.vue";
import DashboardService from "@/src/api/DashboardService.js";
import { message } from "ant-design-vue";
import { exportStatuses } from "@/src/constants/exportConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const downloading = ref(false);

const downloadFile = async () => {
  downloading.value = true;
  try {
    const response = await fetch(`/api/exports/${props.row?.id}/download`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = props.row.file_name || "export.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    message.error("Failed to download export file");
    console.error("Error downloading export file", error);
  } finally {
    downloading.value = false;
  }
};
</script>
